import { render, staticRenderFns } from "./TeleMarketAssign.vue?vue&type=template&id=303dc710&scoped=true"
import script from "./TeleMarketAssign.vue?vue&type=script&lang=js"
export * from "./TeleMarketAssign.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketAssign.vue?vue&type=style&index=0&id=303dc710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303dc710",
  null
  
)

export default component.exports